export const FULLSERVICE_BOOKING_URL = 'https://b2b-hero.pipedrive.com/scheduler/kWo83zCz/einfuhrungsgesprach-b2b-hero';
